

























































import { Component, Vue } from 'vue-property-decorator'
import { Getter } from "vuex-class";
import { getMerchantsLevelList, LevelListDto } from "@/api/customerManage";
import DelLevel from "@/views/customerManage/level/DelLevel.vue";

@Component({
  name: 'LevelSetting',
  components: { DelLevel }
})
export default class LevelSetting extends Vue {
  @Getter companyId!: string

  levelList: LevelListDto[] = []

  created () {
    console.log(this.$route)
    this.getLevelList()
  }

  getLevelList () {
    getMerchantsLevelList({ companyId: this.companyId }).then((res) => {
      this.levelList = res.data.levelList || []
    })
  }

  beforeClose ({ position, instance }) {
    switch (position) {
      case 'cell':
        debugger
        break;
      case 'outside':
        instance.close();
        break;
    }
  }

  toAdd () {
    console.log(11111)
    this.$router.push('/levelHandle')
  }

  delData (id: string) {
    const data: { id: string, toLevelList: LevelListDto[] } = {
      id: id,
      toLevelList: this.levelList.filter(i => { return i.levelId !== id })
    }
      ; (this.$refs.delLevel as any).show(data)
  }

  toEdit (e: any, data: LevelListDto) {
    if (['setting-title','label-style','setting-list'].includes(e.target.className)) {
      this.$router.push({
        path: '/levelHandle',
        query: {
          op: 'edit',
          data: JSON.stringify(data)
        }
      })
    }
  }
}
